import React, { useState } from "react";
import "./ServicesCard.css"; // Keep this for drop-shadow styling if needed

const ServicesCards = ({ cards }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className=" bg-black">
      <div className="container py-12 bg-black mx-auto">
        <h2 className="text-4xl font-bold text-center text-white pb-0 sm:pb-8">
          X-tremetuning Services
        </h2>
        {/* Modal overlay for hovered card */}
        {/* {hoveredIndex !== null && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80"
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div
              className="bg-[#191919] rounded-2xl p-8 max-w-lg w-full relative text-white"
              onMouseLeave={() => setHoveredIndex(null)}
              onMouseEnter={() => setHoveredIndex(hoveredIndex)}
            >
              <button
                className="absolute top-3 right-3 text-2xl font-bold text-white hover:text-red-500"
                onClick={() => setHoveredIndex(null)}
                aria-label="Close"
              >
                &times;
              </button>
              <div className="flex flex-col items-center">
                <img
                  src={cards[hoveredIndex].imgSrc}
                  alt={cards[hoveredIndex].title}
                  className="w-40 h-40 object-cover rounded-full mb-4"
                />
                <h2 className="uppercase text-2xl font-bold leading-snug mb-2">
                  {cards[hoveredIndex].title}
                </h2>
                <video
                  src={cards[hoveredIndex].videoSrc}
                  autoPlay
                  loop
                  muted
                  className="w-full h-48 object-cover rounded-xl mb-4"
                />
                <p className="mb-4">{cards[hoveredIndex].description}</p>
                <a
                  href={cards[hoveredIndex].buttonLink}
                  className="inline-block bg-red-700 text-white px-5 py-2 rounded-lg font-semibold"
                >
                  Meer lezen
                </a>
              </div>
            </div>
          </div>
        )} */}
        {/* previous layout */}
        <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 px-20 lg:px-40  relative group">
          {cards.map((card, index) => {
            const hovered = hoveredIndex === index;
            // const isLastInRow = (index + 1) % 3 === 0; // Adjust for 3-column layout
            // const isSecondInRow = (index + 1) % 2 === 0; // Adjust for 3-column layout

            return (
              <div
                key={index}
                className={`relative h-[400px] transition-all duration-500 ease-in-out
        ${
          hovered
            ? `z-20 min-h-fit w-[90vw] md:w-[75vw] lg:w-[60vw] xl:w-[55vw]
            ${
              index === 0
                ? "-translate-x-[12%] md:-translate-x-[0%] lg:-translate-x-[0%] xl:translate-x-[0%]"
                : ""
            }
            ${
              index === 1
                ? "-translate-x-[12%] md:-translate-x-[50%] lg:-translate-x-[32%] xl:-translate-x-[30%]"
                : ""
            }
            ${
              index === 2
                ? "-translate-x-[12%] md:-translate-x-[0%] lg:-translate-x-1/2 xl:-translate-x-1/2"
                : ""
            }
            ${
              index === 3
                ? "-translate-x-[12%] md:-translate-x-[50%] lg:-translate-x-[0%] xl:-translate-x-[0%]"
                : ""
            }
            ${
              index === 4
                ? "-translate-x-[12%] md:-translate-x-[0%] lg:-translate-x-[32%] xl:-translate-x-[30%]"
                : ""
            }
            ${
              index === 5
                ? "-translate-x-[12%] md:-translate-x-[50%] lg:-translate-x-1/2 xl:-translate-x-1/2"
                : ""
            }`
            : "z-10"
        }
        group-hover:opacity-100 hover:!opacity-100`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {/* Circle background */}
                <div className="absolute top-0 left-0 w-full h-full rounded-[20px] flex justify-center items-center">
                  <div
                    className={`absolute ${
                      hovered
                        ? "w-full h-full rounded-[20px] bg-red-700"
                        : "w-[200px] h-[200px] rounded-full bg-[#191919]"
                    } border-8 border-red-700 transition-all duration-500 drop-shadow-card mr-5`}
                  />
                  <div
                    className={`absolute overflow-hidden rounded-full transition-all duration-500 ${
                      hovered ? "scale-0 delay-0" : "delay-500"
                    } w-[200px] h-[200px] mr-5`}
                  >
                    {/* <video
                      src={card.imgSrc}
                      autoPlay
                      loop
                      muted
                      className="w-full h-full object-cover"
                    /> */}
                    <img
                      src={card.imgSrc}
                      alt="service"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                {/* Hover top-right video */}
                <div
                  className={`relative sm:absolute overflow-hidden rounded-xl transition-all duration-500 ease-in-out w-[300px] h-[250px] md:w-[250px] md:h-[300px] ${
                    hovered
                      ? "top-[35%] sm:top-[55%] left-[45%] sm:left-[82%] transform -translate-x-1/2 -translate-y-1/2 scale-100 rotate-[0deg] sm:rotate-[15deg] delay-500"
                      : "top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 scale-0 rotate-[315deg]"
                  }`}
                >
                  <video
                    src={card.videoSrc}
                    autoPlay
                    loop
                    muted
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Text Content */}
                <div
                  className={`relative sm:absolute transition-all duration-500 w-[90%] sm:w-[55%] left-[10%] mt-[40px] lg:leading-6 xl:leading-8 p-5 text-white ${
                    hovered
                      ? "opacity-100 visible pointer-events-auto left-[3px] mt-[15px] delay-500"
                      : "opacity-0 invisible pointer-events-none"
                  }`}
                >
                  <h2 className="uppercase text-2xl font-bold leading-snug">
                    {card.title}
                  </h2>
                  <p className="mt-2">{card.description}</p>
                  <a
                    href={card.buttonLink}
                    className="inline-block mt-4 bg-[#222222] text-white px-5 py-2 rounded-lg font-semibold"
                  >
                    Meer lezen
                  </a>
                </div>
              </div>
            );
          })}

          {/* Optional dark overlay */}
          {/* <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition duration-300 z-0 pointer-events-none" /> */}
        </div>
      </div>
    </div>
  );
};

export default ServicesCards;
